import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NombreFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NOMBRE' htmlFor='input-nombre' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='nombre'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-nombre'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombreFormGroup)
